import { Routes,Route,Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import AdminRoutes from "./routes/AdminRoutes/AdminRoutes";
import UserRoutes from "./routes/UserRoutes/UserRoutes";

import "./App.css";


function App() {
  const location = useLocation();

  useEffect(() => {
    const isAdmin = location.pathname.startsWith('/admin');
    // Toggle classe sul body per area admin
    document.body.classList.toggle('font-sans', isAdmin);

    // Aggiorna dinamicamente il CSS dell'area
    const linkId = 'area-css';
    const cssFile = isAdmin ? '/admin.css' : '/user.css';
    let link = document.getElementById(linkId);
    if (!link) {
      link = document.createElement('link');
      link.id = linkId;
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }
    if (link.getAttribute('href') !== cssFile) {
      link.setAttribute('href', cssFile);
    }
  }, [location.pathname]);

  return (
    <div>
      <Routes>
        {/* Rotte amministratore */}
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="*" element={<UserRoutes />} /> 
      </Routes>
    </div>
  );
}

export default App;
